// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"691":"component---src-pages-index-tsx","883":"component---src-pages-404-js"}[chunkId] + "-" + {"691":"ca13cb3f58f2b3d8bdbc","883":"fa2abe883b96a6e99a78"}[chunkId] + ".js";
};